import Reveal from '@/components/base/Reveal';

const principles = [
  {
    key: 'One Market',
    body: 'The framework trades a single instrument — XAUUSD — and nothing else. Focusing on one market lets the system study how gold actually behaves, instead of spreading the same rules thinly across dozens of pairs. Every behaviour it learns is specific to gold.',
    notThis: 'It does not jump across many markets to look busy or diversified.',
  },
  {
    key: 'Condition-Based',
    body: 'A move in price is not, on its own, a reason to trade. A position is only opened when the exact conditions the system is built to check are all met — if even one is missing, it does nothing. Sitting out is treated as a valid outcome, not a missed chance.',
    notThis: 'It does not open a trade just because the price moved.',
  },
  {
    key: 'Both Directions',
    body: 'Long and short setups are judged by the same standard and evaluated on their own merits, so the system follows market structure rather than a personal bias. It is as willing to sell as it is to buy; direction is decided by the read, not by habit.',
    notThis: 'It does not lean to one direction because it “feels” bullish.',
  },
  {
    key: 'Fully Recorded',
    body: 'Every closed position — the wins and the losses alike — goes into the trading record. The record exists to be checked and reviewed, so performance can be judged on all of the trades rather than a selected few.',
    notThis: 'It does not hide or quietly drop the losing trades.',
  },
];

function CorePrinciples() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-data tracking-[0.24em] text-primary-600">
              FRAMEWORK
            </span>
            <span className="w-8 h-px bg-primary-400"></span>
            <span className="text-[11px] font-data tracking-[0.2em] text-foreground-400">
              WHAT THE STRATEGY FOLLOWS
            </span>
          </div>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[44px] lg:text-[50px] max-w-[760px]">
            Four Principles Behind The System.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {principles.map((item, idx) => (
            <Reveal key={item.key} delay={idx * 90} className="h-full">
              <div className="group h-full flex flex-col rounded-lg border border-background-300 bg-background-50 p-6 transition-all duration-200 hover:border-primary-300 hover:-translate-y-1 cursor-pointer">
                <p className="font-heading font-bold text-foreground-950 text-[18px]">
                  {item.key}
                </p>
                <p className="mt-3 text-[14px] leading-relaxed text-foreground-600">{item.body}</p>
                <div className="mt-auto pt-5">
                  <div className="flex items-start gap-2 border-t border-background-200 pt-4">
                    <span className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-close-line text-[14px] text-foreground-400"></i>
                    </span>
                    <span className="text-[12.5px] leading-snug text-foreground-500">
                      {item.notThis}
                    </span>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CorePrinciples;